import React from 'react';
import { VitalityLandingPage } from './pages/VitalityLandingPage';
export function App() {
  return <VitalityLandingPage data-id="element-0" />;
}